import { Box, Button } from '@mui/material';
import React from 'react';
import CustomAccordion from '../../../components/Utils/CustomAccordion';
import { GlobalVariables } from '../../../globalVar';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import { useEffect } from 'react';

const VisitConcat = ({ visitId }) => {
  const [visitInfo, setVisitInfo] = useState({});
  const [variableToCopy, setVariableToCopy] = useState(''); // Variable to copy
  const [copyStatus, setCopyStatus] = useState('');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(variableToCopy);
      setCopyStatus('Copiado!');
      setTimeout(() => setCopyStatus(''), 2000); // Clear status after 2 seconds
    } catch (err) {
      setCopyStatus('Error al copiar.');
    }
  };

  const fetchVisit = async () => {
    const endpoint = `${GlobalVariables.getURL()}getVisitById/${visitId}`;

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.status === 200) {
        setVisitInfo(response.data.data);
        setVariableToCopy(response.data.data.concat_failure);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchVisit();
  }, []);

  return (
    <div>
      <Box sx={{ height: 'auto', width: '100%', marginTop: '1rem' }}>
        <CustomAccordion
          title='Detalles del concatenado'
          data={[
            { label: 'ID', value: visitInfo.id },
            { label: 'Ticket', value: visitInfo.oxxo_ticket },
            { label: 'Fecha y hora del ticket', value: visitInfo.ticket_date },
            { label: 'CR', value: visitInfo.cr },
            { label: 'Sucursal', value: visitInfo.site_name },
            { label: 'SLA', value: visitInfo.failure_name },
            {
              label: 'Fecha de vencimiento',
              value: visitInfo.last_commitment_date,
            },
            { label: 'Hora', value: visitInfo.failure_hour },
            { label: 'Contacto sucursal', value: visitInfo.client_ti },
            {
              label: 'Comentario del servicio',
              value: visitInfo.failure_note,
            },
          ]}
        />
      </Box>
      <Box sx={{ height: 'auto', width: '100%', marginTop: '1rem' }}>
        <Button
          variant='contained'
          size='small'
          onClick={handleCopy}
          sx={{ marginBottom: '10px' }}
        >
          Copiar
        </Button>{' '}
        {copyStatus}
        <p style={{ fontWeight: 'bold', fontSize: '18px' }}>{variableToCopy}</p>
      </Box>
    </div>
  );
};

export default VisitConcat;
